<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { usePortalStore } from '@/store/portal'
import AppIcon from './AppIcon.vue'
// 학습지원센터 하위 화면 공통 틀: 왼쪽 메뉴 + 제목 위 위치 표시(홈 › 그룹 › 제목) + 제목.
const props = defineProps({ title: { type: String, required: true }, group: { type: String, default: '학습지원센터' }, parent: { type: String, default: '/support' } })
const route = useRoute(), portal = usePortalStore()
const siblings = computed(() => portal.menus.find(menu => menu.to === props.parent)?.children || [])
</script>
<template>
  <section class="portal-section portal-info"><div class="portal-container">
    <div class="portal-info-grid"><aside class="portal-sidebar"><h2>{{ group }}</h2><nav aria-label="하위 메뉴"><NuxtLink v-for="item in siblings" :key="item.to" :to="item.to" :aria-current="route.path === item.to ? 'page' : undefined">{{ item.title }}<AppIcon name="chevronRight" :size="14" /></NuxtLink></nav></aside>
      <div class="portal-info-content"><nav class="portal-breadcrumb" aria-label="현재 위치"><NuxtLink to="/">홈</NuxtLink><span aria-hidden="true">›</span><span>{{ group }}</span><span aria-hidden="true">›</span><span>{{ title }}</span></nav><h1>{{ title }}</h1><slot /></div>
    </div>
  </div></section>
</template>
